module.exports = __webpack_public_path__ + "img/gallery3.558fa7e.jpg";